import { render, staticRenderFns } from "./finishList.vue?vue&type=template&id=51cb193f&scoped=true"
import script from "./finishList.vue?vue&type=script&lang=js"
export * from "./finishList.vue?vue&type=script&lang=js"
import style0 from "./finishList.vue?vue&type=style&index=0&id=51cb193f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cb193f",
  null
  
)

export default component.exports